import { GoabButton } from "@abgov/react-components"

export const LoggedOut = () => {
  return (<>
    <div className="content">
      <h1>Logged Out</h1>
      <p>You have successfully logged out from the Wildfire Applications Portal</p>
      <GoabButton size="compact" onClick={() => window.location.href = window.location.origin}>Login</GoabButton>
    </div>
  </>)
}


